import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {StringTemplate} from '@spartacus/core';
import {ConfigService} from './config.service';
import {isPlatformBrowser} from '@angular/common';
import {UntilDestroy} from '@ngneat/until-destroy';
import {DcpApiPlatforms} from '../models/dcp-api-platforms.model';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class EndpointsService {
  private isIasActive: boolean = false;

  constructor(
    private configService: ConfigService,
    @Inject(PLATFORM_ID) public platformId: string,
  ) {
    // check if we are in token exchange mode and need to use UDEX gateway for API calls.
    if (isPlatformBrowser(this.platformId)) {
      this.isIasActive = window.sessionStorage.getItem('iasActiveFlag') === 'true';
    }
  }

  buildUrl(platform: string, namespace: string, endpoint: string, urlParams?: object): string {
    let url = this.getEndpoint(platform, namespace, endpoint);
    url = this.buildUrlWithParameters(url, urlParams ? urlParams : {});
    return url;
  }

  getEndpoint(platform: string, namespace: string, endpoint: string): string {
    const namespacePath = platform === DcpApiPlatforms.KYMA && this.isIasActive ? 'namespaceUdex' : 'namespace';
    const subdomain: string = this.configService.getObject(`${platform}.${namespacePath}`)[namespace];
    const endpointPath: string = this.configService.getString(`${platform}.${namespace}.${endpoint}`);
    if (!subdomain) {
      return '';
    }
    return subdomain + endpointPath;
  }

  private buildUrlWithParameters(url: string, urlParams: object): string {
    if (urlParams) {
      url = StringTemplate.resolve(url, urlParams, true);
    }
    return url;
  }
}
